export default __webpack_public_path__ + "static/media/img-guide-gt-popup-1-fr_fr@2x.a87fc01d.png";